import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dialog", "dialogNoiseFilter", "dialogPersonFilter", "dialogSessionFilter", "panel", "personFilter", "sessionFilter"]

  connect() {
    this.closeOnBackdrop = this.closeOnBackdrop.bind(this)
    if (this.hasDialogTarget) this.dialogTarget.addEventListener("click", this.closeOnBackdrop)
    this.restoreNoisePreference()
  }

  disconnect() {
    if (this.hasDialogTarget) this.dialogTarget.removeEventListener("click", this.closeOnBackdrop)
  }

  toggleFilters() {
    if (this.usesDialog && this.hasDialogTarget) {
      if (!this.dialogTarget.open) this.dialogTarget.showModal()
      return
    }

    this.togglePanel()
  }

  applyFilters() {
    const personId = this.hasPersonFilterTarget ? this.personFilterTarget.value : ""
    const sessionId = this.hasSessionFilterTarget ? this.sessionFilterTarget.value : ""

    this.filterRows(personId, sessionId)
  }

  applyDialogFilters() {
    const personId = this.hasDialogPersonFilterTarget ? this.dialogPersonFilterTarget.value : ""
    const sessionId = this.hasDialogSessionFilterTarget ? this.dialogSessionFilterTarget.value : ""

    if (this.hasPersonFilterTarget) this.personFilterTarget.value = personId
    if (this.hasSessionFilterTarget) this.sessionFilterTarget.value = sessionId
    this.filterRows(personId, sessionId)
  }

  closeFilters() {
    if (this.hasDialogTarget) this.dialogTarget.close()
  }

  resetFilters(event) {
    event.preventDefault()
    if (this.hasDialogNoiseFilterTarget) this.dialogNoiseFilterTarget.value = "hidden"
    if (this.hasDialogPersonFilterTarget) this.dialogPersonFilterTarget.value = ""
    if (this.hasDialogSessionFilterTarget) this.dialogSessionFilterTarget.value = ""
    if (this.hasPersonFilterTarget) this.personFilterTarget.value = ""
    if (this.hasSessionFilterTarget) this.sessionFilterTarget.value = ""
    this.setNoiseState("hidden")
    this.filterRows("", "")
  }

  setNoise(event) {
    this.setNoiseState(event.target.value)
  }

  filterRows(personId, sessionId) {
    this.rows.forEach(row => {
      const personMismatch = Boolean(personId) && row.dataset.activityUserId !== personId
      const sessionMismatch = Boolean(sessionId) && row.dataset.activitySessionId !== sessionId
      row.classList.toggle("filtered-out", personMismatch || sessionMismatch)
    })

    this.updateDayDividers()
  }

  togglePanel() {
    if (this.hasPanelTarget) this.panelTarget.classList.toggle("hidden")
  }

  setNoiseState(state) {
    const visible = state === "visible"
    const feed = this.element.querySelector(".activity-list")
    if (feed) feed.classList.toggle("show-noise", visible)
    if (this.hasDialogNoiseFilterTarget) this.dialogNoiseFilterTarget.value = visible ? "visible" : "hidden"
    this.storeNoisePreference(visible ? "visible" : "hidden")
  }

  restoreNoisePreference() {
    const state = this.readNoisePreference() || "hidden"
    this.setNoiseState(state)
  }

  readNoisePreference() {
    try {
      return window.localStorage.getItem("hitl:activity:noise")
    } catch {
      return null
    }
  }

  storeNoisePreference(state) {
    try {
      window.localStorage.setItem("hitl:activity:noise", state)
    } catch {
      // Ignore private-mode storage failures; the visible feed state is already updated.
    }
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.closeFilters()
  }

  updateDayDividers() {
    const list = this.element.querySelector(".activity-list")
    if (!list) return

    const children = Array.from(list.children)
    children.forEach((child, index) => {
      if (!child.classList.contains("activity-day-divider")) return

      const nextDividerIndex = children.findIndex((candidate, candidateIndex) => {
        return candidateIndex > index && candidate.classList.contains("activity-day-divider")
      })
      const section = children.slice(index + 1, nextDividerIndex === -1 ? children.length : nextDividerIndex)
      const hasVisibleRows = section.some(row => {
        return row.classList.contains("activity-item") && !row.classList.contains("filtered-out")
      })
      child.classList.toggle("filtered-out", !hasVisibleRows)
    })
  }

  get rows() {
    return this.element.querySelectorAll(".activity-item")
  }

  get usesDialog() {
    return window.matchMedia("(max-width: 720px)").matches
  }
}
